<template>
  <div>
    <PageDynamicBreadcrumb custom-current-page="Overview" />
    <PageHeader title="Ad Templates Overview">
      <template v-slot:actions>
        <q-btn label="New Template" to="/templates/editor" color="primary" />
      </template>
    </PageHeader>

    <DataTable
      table-key="adTemplatesOverview"
      row-key="id"
      title="Templates"
      :columns="columns"
      :rows="templates"
      :loading="loading"
      :pagination="pagination"
      :downloadable="false"
      :refreshable="false"
      :customizable="false"
      :filterable="true"
      :searchable="true"
      :disable-state="true"
    >
      <template v-slot:actions="row">
        <ActionsDropdownButton
          :actions="[
            {
              action: () =>
                $router.push({
                  path: '/templates/editor/' + row.id
                }),
              label: 'Edit'
            },
            {
              action: () => promptDeleteTemplate(row),
              label: 'Delete'
            }
          ]"
        />
      </template>
    </DataTable>
  </div>
</template>

<script>
import { Dialog } from "quasar";
import ConfirmationModalDelete from "@/components/UI/ConfirmationModalDelete";
import PageHeader from "@/components/UI/PageHeader";
import PageDynamicBreadcrumb from "@/components/UI/PageDynamicBreadcrumb";
import DataTable from "@/components/DataTable";
import ActionsDropdownButton from "@/components/UI/ActionsDropdownButton";
import moment from "moment/moment";

export default {
  name: "TemplatesOverview",
  components: {
    ActionsDropdownButton,
    DataTable,
    PageDynamicBreadcrumb,
    PageHeader
  },
  data() {
    return {
      loading: true,
      pagination: {
        sortBy: "id",
        descending: true,
        page: 1,
        rowsPerPage: 25
      },
      columns: [
        {
          name: "id",
          label: "Template ID",
          field: "id",
          sortable: true,
          sort: (a, b) => this.sortInteger(a, b),
          type: "dimension"
        },
        {
          name: "name",
          label: "Template Name",
          field: "name",
          sortable: true,
          type: "dimension"
        },
        {
          name: "dimensions",
          label: "Dimensions",
          field: row => row.width + " × " + row.height,
          sortable: false,
          type: "dimension"
        },
        {
          name: "time_created",
          label: "Time Created",
          field: row => moment.utc(row.time_created).local(),
          format: val => (!val ? "-" : moment(val).format("lll")),
          sortable: true,
          sort: (a, b) => this.sortDate(a, b),
          align: "left",
          type: "metric",
          metricType: "date"
        },
        {
          name: "time_updated",
          label: "Time Last Edit",
          field: row => !row.time_updated ? null : moment.utc(row.time_updated).local(),
          format: val => (!val ? "-" : moment(val).format("lll")),
          sortable: true,
          sort: (a, b) => this.sortDate(a, b),
          align: "left",
          type: "metric",
          metricType: "date"
        },
        {
          name: "actions",
          label: "",
          field: "",
          filterable: false
        }
      ]
    };
  },
  computed: {
    templates() {
      return this.loading ? [] : this.$store.state.templates.list;
    }
  },
  mounted() {
    this.$store.dispatch("templates/POPULATE_LIST").finally(() => {
      setTimeout(() => {
        this.loading = false;
      }, 100);
    });
  },
  methods: {
    promptDeleteTemplate(template) {
      Dialog.create({
        component: ConfirmationModalDelete,
        componentProps: {
          descriptor: template.name
        }
      }).onOk(dialog => {
        dialog.submitting = true;
        this.$store
          .dispatch("templates/POST_REQUEST", {
            endpoint: "delete",
            params: { id: template.id }
          })
          .then(() => {
            this.triggerActionOutcomeAlert("delete", true);
            dialog.hide();
          })
          .catch(() => {
            this.triggerActionOutcomeAlert("delete", false);
          })
          .finally(() => {
            dialog.submitting = false;
          });
      });
    }
  }
};
</script>

<style scoped lang="scss"></style>
